import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DadosPlano } from 'src/app/models/dados-plano';
import { AulaService } from 'src/app/services/aula/aula.service';
import { CursoService } from 'src/app/services/curso/curso.service';
import { PlanoService } from 'src/app/services/plano/plano.service';
import { MessageUtil } from 'src/app/utils/message.util';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SiteService } from 'src/app/services/site/site.service';
import { Site } from 'src/app/models/site';
import { AulaOndeParou } from 'src/app/models/aula-onde-parou';

@Component({
  selector: 'app-listagem-aula',
  templateUrl: './listagem-aula.component.html',
  styleUrls: ['./listagem-aula.component.scss'],
})
export class ListagemAulaComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  aulaOndeParou: AulaOndeParou;
  cronogramas: any[];
  meses: any[];
  dataSelecionada = new Date();
  dadosPlano = new DadosPlano();
  @ViewChild('rowAulaAtiva') rowAulaAtiva: ElementRef;
  // @ViewChild('rowAulaAtiva', { static: false }) rowAulaAtiva: ElementRef;
  layout = new Site();

  constructor(
    private aulaService: AulaService,
    private planoService: PlanoService,
    private cursoService: CursoService,
    private route: ActivatedRoute,
    private siteService: SiteService
  ) {}

  ngOnInit() {
    this.trocaLayout();
    this.getAulaOndeParou();
    this.getMeses();
  }

  getAulaOndeParou() {
    this.aulaService.getAulaOndeParou().subscribe((aulaOndeParou) => {
      this.aulaOndeParou = aulaOndeParou;

      console.log('objeto aula onde parou', this.aulaOndeParou);
    });
  }

  async trocaLayout() {
    let corPrincipal = '';
    const dropdown = document.getElementById('dropdown');

    if (environment.medAulaId === null) {
      corPrincipal = '#f14a43';
      dropdown.style.backgroundColor = corPrincipal;
      document.head.insertAdjacentHTML(
        'beforeend',
        `<style type="text/css">
        .btn-danger {
          background-color: ` +
          corPrincipal +
          `;
          border-color: ` +
          corPrincipal +
          `;
        }
      </style>`
      );
    } else {
      this.siteService.getSiteLayout(environment.medAulaId).subscribe(
        (layout) => {
          this.layout = layout;
          corPrincipal = this.layout.corPrincipal;
          dropdown.style.backgroundColor = corPrincipal;
          document.head.insertAdjacentHTML(
            'beforeend',
            `<style type="text/css">
            .btn-danger {
              background-color: ` +
              corPrincipal +
              `;
              border-color: ` +
              corPrincipal +
              `;
            }
            .btn-danger:hover,
            .btn-danger:focus,
            .btn-danger:not(:disabled):not(.disabled):active {
              background-color: ` +
              corPrincipal +
              `;
              border-color: ` +
              corPrincipal +
              `;
            }
            .avaliar-aula:hover {
              color: ` +
              corPrincipal +
              `;
            }
          </style>`
          );
        },
        () => this.blockUI.stop()
      );
    }
    this.blockUI.stop();
  }

  getMeses() {
    this.blockUI.start(MessageUtil.AGUARDE);
    const planoLocalStorage = JSON.parse(localStorage.getItem('planoSelecionado'));
    if (planoLocalStorage) {
      this.planoService.getMesesDisponiveis(planoLocalStorage.id).subscribe(
        (meses) => {
          this.blockUI.stop();
          this.meses = meses ? meses.map((m) => ({ date: new Date(m), isDisabled: this.shouldDisable(m), m })) : [];
          this.definirDataSelecionada();
          this.getAulasCronograma();
        },
        () => this.blockUI.stop()
      );
    }
  }

  shouldDisable(dateStr: string): Boolean {
    // tslint:disable-next-line:radix
    const receivedYear = parseInt(dateStr.split('-')[0].toString());
    // tslint:disable-next-line:radix
    const receivedMonth = parseInt(dateStr.split('-')[1].toString());

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    // se o ano do mes recebido for maior que o ano atual, desabilita o mês, pois é um mês futuro e o usuário não pode selecionar
    if (receivedYear > currentYear) {
      return true;
    } else {
      // se o mês recebido for maior que o mês atual, é futuro e o usuário não pode selecionar. Então desabilita. Se não, pode habilitar
      return receivedMonth > currentMonth;
    }
  }

  definirDataSelecionada() {
    const dataLocalStorage = JSON.parse(localStorage.getItem('dataSelecionada'));
    if (dataLocalStorage) {
      const date = new Date(dataLocalStorage.ano, dataLocalStorage.mes, dataLocalStorage.dia);
      this.dataSelecionada =
        this.meses.find((m) => m.date.getFullYear() === date.getFullYear() && m.date.getMonth() === date.getMonth())
          .date || this.meses[this.meses.length - 1].date;
    } else {
      const date = new Date();
      this.dataSelecionada =
        this.meses.find((m) => m.date.getMonth() === date.getMonth()).date || this.meses[this.meses.length - 1].date;
    }
  }

  mesChanged(item: any) {
    this.dataSelecionada = item;
    this.getAulasCronograma();
    localStorage.setItem(
      'dataSelecionada',
      JSON.stringify({
        ano: item.getFullYear(),
        mes: item.getMonth(),
        dia: item.getDate(),
      })
    );
  }

  getAulasCronograma() {
    this.blockUI.start(MessageUtil.AGUARDE);
    const planoLocalStorage = JSON.parse(localStorage.getItem('planoSelecionado'));
    if (planoLocalStorage) {
      this.aulaService.getAulasCronograma(planoLocalStorage.id, this.dataSelecionada).subscribe(
        (cronogramas: any[]) => {
          this.blockUI.stop();
          const itemsAux: any[] = [];

          for (const item of cronogramas) {
            if (item.modulos.length !== 0) {
              itemsAux.push(item);
            }
          }

          this.cronogramas = itemsAux || [];
          console.log('cronogramas: ' + this.cronogramas);

          this.getDadosPlano();
        },
        () => this.blockUI.stop()
      );
    }
  }

  getDadosPlano() {
    this.blockUI.start(MessageUtil.AGUARDE);
    try {
      this.cursoService.getDadosCurso(this.dataSelecionada.getMonth() + 1).subscribe(
        (dadosPlano: any) => {
          this.blockUI.stop();
          this.dadosPlano = dadosPlano;
        },
        () => this.blockUI.stop()
      );
    } catch (error) {
      this.blockUI.stop();
    }
  }
}
